import { Link } from 'react-router-dom';
import { openRandomPlayLink } from '../../../config/playLinks';
import { PRIMARY_NAV_ITEMS, ROUTES } from '../../../router/routes';

export default function Footer() {
  return (
    <footer className="bg-gray-50 text-gray-900 pt-12 pb-6 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-10">
          <div className="lg:col-span-2">
            <Link to={ROUTES.home} className="flex items-center mb-4">
              <img src="/footer-logo.png" alt="KoalaBet logo" className="h-10 w-auto" />
            </Link>
            <p className="text-gray-600 leading-relaxed mb-6 text-sm">
              KoalaBet is an independent casino review site providing expert analysis, honest reviews, and comprehensive guides to help players make informed decisions. We've been serving the online gaming community since 2020.
            </p>
            <div className="flex items-center flex-wrap gap-2 mb-6">
              <img src="/safety-logos/cga.png" alt="CGA" className="h-6 w-auto object-contain" />
              <img src="/logo-ecogra.svg" alt="eCOGRA" className="h-4 w-auto object-contain" />
              <img src="/logo-gli.svg" alt="GLI" className="h-4 w-auto object-contain" />
              <img src="/logo-itech-labs.svg" alt="iTech Labs" className="h-6 w-auto object-contain" />
              <img src="/logo-mga.svg" alt="MGA" className="h-6 w-auto object-contain" />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-6">
          <div className="text-xs text-gray-600 leading-relaxed space-y-3">
            <p>
              <strong className="text-gray-900">Gambling Responsibly:</strong> KoalaBet is committed to promoting responsible gambling. If you or someone you know has a gambling problem, please seek help. Visit <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="text-green-700 hover:underline">BeGambleAware.org</a> or call the National Gambling Helpline at 1-800-522-4700.
            </p>
            <p>
              <strong className="text-gray-900">18+ Only:</strong> You must be 18 years or older to gamble. Gambling can be addictive. Play responsibly and only gamble what you can afford to lose.
            </p>
            <p>
              <strong className="text-gray-900">Affiliate Disclosure:</strong> KoalaBet may receive compensation from the casinos and brands featured on this site. This compensation may impact how and where casinos appear on the site, but does not influence our reviews, ratings, or recommendations. All reviews are based on our independent analysis and expert opinion.
            </p>
            <p>
              <strong className="text-gray-900">Disclaimer:</strong> The information provided on this website is for informational purposes only. We do not guarantee the accuracy or completeness of any information. Always verify bonus terms and conditions directly with the casino before playing.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row items-center justify-between mt-6 pt-6 border-t border-gray-300">
            <p className="text-xs text-gray-500">
              © 2026 KoalaBet. All rights reserved.
            </p>
            <div className="flex items-center gap-2 mt-3 md:mt-0">
              <a href="/" className="w-11 h-11 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="/" className="w-11 h-11 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="/" className="w-11 h-11 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="/" className="w-11 h-11 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}